import React from 'react'
import { Container, Grid, Typography } from '@toptal/picasso'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { ReactComponent as Logo } from './logo.svg'
import MergeLink from '../MergeLink/MergeLink'
import ExampleDataLink from '../ExampleDataLink'
import { exampleDataPicked } from '../../actions'

type ExampleLink = Array<Record<'title' | 'slug', string>>

interface IProps {
  title: string
  tagline: string
  subtitles: string[]
  typeSuggestion: string
  mergeLinkText: string
  loadSamplesText: string
  exampleLinks: ExampleLink
  onExampleLinkClick(type: string): void
}

const LogoWrapper = styled.span`
  display: inline-block;
  width: 256px;

  @media (max-width: 767px) {
    width: 128px;
  }
`

const Hero: React.FunctionComponent<IProps> = props => {
  function getSamplesDescription(sampleDescriptionsProps: IProps) {
    return (
      <Typography variant='body'>
        {sampleDescriptionsProps.loadSamplesText} {'('}
        {buildexampleLinks(sampleDescriptionsProps.exampleLinks)}
        {')'}
      </Typography>
    )
  }

  const buildexampleLinks = (exampleLinks: ExampleLink) => {
    return exampleLinks.map((exampleLink, index) => {
      return [
        <ExampleDataLink
          key={exampleLink.slug}
          onClick={props.onExampleLinkClick}
          text={exampleLink.title}
          type={exampleLink.slug}
        />,
        index === exampleLinks.length - 1 ? '' : ',  ' // join elements with comma
      ]
    })
  }

  return (
    <Container top={2}>
      <Grid>
        <Grid.Item medium={4} small={12}>
          <LogoWrapper>
            <Logo />
          </LogoWrapper>
        </Grid.Item>

        <Grid.Item medium={8} small={12}>
          <Container bottom={1}>
            <Typography
              style={{ fontWeight: 'bold', textShadow: '0 1px 1px #333' }}
              variant='h1'
            >
              {props.title}
            </Typography>
          </Container>

          <Container bottom={1}>
            <Container bottom={0.5}>
              <Typography as='h2' variant='large'>
                {props.tagline}
              </Typography>
            </Container>
            {props.subtitles.map(subtitle => {
              return (
                <Container bottom={0.5} key={subtitle}>
                  <Typography variant='large'>{subtitle}</Typography>
                </Container>
              )
            })}
          </Container>

          <Container bottom={0.5}>
            <Typography variant='body'>
              {props.typeSuggestion} <MergeLink label={props.mergeLinkText} />
            </Typography>
          </Container>

          {getSamplesDescription(props)}
        </Grid.Item>
      </Grid>
    </Container>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onExampleLinkClick: (type: string) => {
    dispatch(exampleDataPicked(type))
  }
})

export default connect(null, mapDispatchToProps)(Hero)
